import { z } from 'zod';
import { UlidSchema, IsoTimestampSchema } from './common.js';

export const VisitaEstadoSchema = z.enum(['ingresada', 'finalizada']);
export type VisitaEstado = z.infer<typeof VisitaEstadoSchema>;

export const VisitaOrigenSchema = z.enum(['qr', 'walk_in']);
export type VisitaOrigen = z.infer<typeof VisitaOrigenSchema>;

export const VisitaTipoSchema = z.enum(['familiar', 'delivery', 'proveedor', 'servicio']);
export type VisitaTipo = z.infer<typeof VisitaTipoSchema>;

export const VisitaSchema = z.object({
  id: UlidSchema,
  tenantId: z.string(),
  unidadId: UlidSchema,
  unidadNumero: z.string(),
  origen: VisitaOrigenSchema,
  visitorPassId: UlidSchema.optional(),
  registradoPorUserId: z.string(),
  registradoPorNombre: z.string(),
  visitorNombre: z.string().min(2).max(200),
  visitorDni: z.string().min(5).max(20),
  vehiclePatent: z.string().max(10).optional(),
  tipo: VisitaTipoSchema.default('familiar'),
  estado: VisitaEstadoSchema,
  ingresoAt: IsoTimestampSchema,
  egresoAt: IsoTimestampSchema.nullable(),
  autoCerrada: z.boolean(),
  observaciones: z.string().max(500).optional(),
});
export type Visita = z.infer<typeof VisitaSchema>;

export const CreateWalkInVisitaRequestSchema = z.object({
  unidadId: UlidSchema,
  visitorNombre: z.string().min(2).max(200),
  visitorDni: z.string().min(5).max(20),
  vehiclePatent: z.string().max(10).optional(),
  tipo: VisitaTipoSchema.optional(),
  observaciones: z.string().max(500).optional(),
});
export type CreateWalkInVisitaRequest = z.infer<typeof CreateWalkInVisitaRequestSchema>;

export const ListVisitasQuerySchema = z.object({
  estado: VisitaEstadoSchema.optional(),
  tipo: VisitaTipoSchema.optional(),
  unidadId: UlidSchema.optional(),
  desde: IsoTimestampSchema.optional(),
  hasta: IsoTimestampSchema.optional(),
});
export type ListVisitasQuery = z.infer<typeof ListVisitasQuerySchema>;
